import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

const AutoReplenishmentRequestPage = lazy(
  () =>
    import(
      "../../../../../components/WMS/AutoReplenishment/AutoReplenishmentRequestPage.tsx"
    ),
)

export const Route = createFileRoute(
  "/_layout/WMS/auto-replenishment/requests/$requestId",
)({
  component: AutoReplenishmentRequestRoute,
})

function AutoReplenishmentRequestRoute() {
  const { requestId } = Route.useParams()
  return (
    <LazyRoutePage>
      <AutoReplenishmentRequestPage requestId={requestId} />
    </LazyRoutePage>
  )
}
